// @flow
import React, { Component } from 'react'

import { formatDateYMD, processStringToDate, saveDateRange } from '../timeutils'
import './CustomFilter.css'
import error from '../Icons/icon-error-red.svg'
import DatePicker, { registerLocale } from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { connect } from 'react-redux'
import { isSecondRoute } from '../../utils/router-utils'
import en from 'date-fns/locale/es'
registerLocale('en', en)
type Props = {
  filterBy: Function,
  dateFilterStore: {
    currentComponent: string,
    previousComponent: string,
    screens: Array
  }
}

type State = {
  start: ?string,
  end: ?string,
  error: ?string,
}

/**
  * Button for custom filter
  * @class
  * @extends Component
*/
class CustomFilter extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    const { currentComponent, previousComponent, screens } = props.dateFilterStore
    const actualComponent = isSecondRoute(currentComponent) ? previousComponent : currentComponent
    if (screens[actualComponent] && screens[actualComponent].dateInterval) {
      this.state = processStringToDate(screens[actualComponent].dateInterval)
    } else {
      // generate a week ago
      const start: Date = new Date()
      start.setDate(start.getDate() - 7)
      const end: Date = new Date()
      this.state = {
        start,
        end
      }
    }
    this.saveFilter = this.saveFilter.bind(this)
    this.changeStart = this.changeStart.bind(this)
    this.changeEnd = this.changeEnd.bind(this)
    this.addDays = this.addDays.bind(this)
    this.subDays = this.subDays.bind(this)
    this.minDate = this.minDate.bind(this)
  }

  /**
    * @func changeStart
    * @param {Object} newStart
  */
  changeStart (newStart) {
    this.setState({ start: newStart })
    if (this.state.error && newStart <= this.state.end) {
      this.setState({ error: false })
    }
  }

  /**
    * @func changeEnd
    * @param {Object} newEnd
  */
  changeEnd (newEnd) {
    this.setState({ end: newEnd })
    if (this.state.error && this.state.start <= newEnd) {
      this.setState({ error: false })
    }
  }

  /** @func saveFilter */
  saveFilter () {
    if (this.state.start <= this.state.end) {
      const { start, end } = this.state
      const startDate = formatDateYMD(start) // start.toISOString().slice(0,10)
      const endDate = formatDateYMD(end) // end.toISOString().slice(0,10)
      this.props.filterBy(saveDateRange({ start: startDate, end: endDate }), true)
    } else {
      this.setState({ error: 'Invalid Date Range' })
    }
  }

  addDays (date, days) {
    const result = new Date(date)
    result.setDate(result.getDate() + days)
    return result
  }

  subDays (date, days) {
    const result = new Date(date)
    result.setDate(result.getDate() - days)
    return result
  }

  minDate () {
    const dayMin = new Date()
    dayMin.setDate(dayMin.getDate() - 365)
    return dayMin
  }

  /** render function */
  render () {
    return (
      <div className='CustomFilter'>
        View custom timeframe from
        <DatePicker
          locale='en'
          selected={this.state.start}
          onChange={this.changeStart}
          dateFormat='yyyy/MM/dd'
          maxDate={new Date()}
          minDate={this.minDate()}
        /> to<DatePicker
          locale='en'
          selected={this.state.end}
          onChange={this.changeEnd}
          dateFormat='yyyy/MM/dd'
          maxDate={new Date()}
          minDate={this.minDate()}
        /><button onClick={this.saveFilter} className='blue'>Update Timeframe</button>
        {this.state.error ? <div className='alert'><img src={error} alt='Alert' /> {this.state.error}</div> : '' }
      </div>
    )
  }
}
/**
 * @func mapStateToProps
 * @param {Object} state
 * @param {Object} ownProps
 * @returns {Object}
 */
const mapStateToProps = (state, ownProps) => {
  return {
    dateFilterStore: state.dateFilter
  }
}

/**
 * @func mapStateToProps
 * @param {Object} dispatch
 * @returns {Object}
 */
const mapDispatchToProps = dispatch => {
  return {

  }
}

/** @func LinkedAdmin */
const CustomFilterRedux = connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomFilter)

export default CustomFilterRedux
